export default "__VITE_ASSET__BI8OCut4__"